export default __webpack_public_path__ + "static/media/ipBan.05c8ea88.png";